export const environment = {
    production: true,
    apiUrl: "https://gezalov.ru/api",
    apiLambdaUrl: "",
    build: "0.10.5"
};
